"use client"

import { cn } from "../../lib/utils"

interface MoonUISkeletonProProps extends React.HTMLAttributes<HTMLDivElement> {}

export function MoonUISkeletonPro({
  className,
  ...props
}: MoonUISkeletonProProps) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

// Backward compatibility export
export { MoonUISkeletonPro as Skeleton }